import React from "react";
import { Popover } from "antd";
import { object, string } from "prop-types";
import { ROW_TYPE, PAGES } from "../../core/_utils/constants";
import { IconLight } from "../";

const PopoverRowContent = (page, row) => {
  switch (row.rowType) {
    case ROW_TYPE.OBJECT:
      if (page === PAGES.FINANCIAL)
        return (
          <div>
            <div>
              <b>Filtered DUIDS:</b> {row.duids.join(",")}
            </div>
            {/*<div><b>Fuel type</b></div>*/}
          </div>
        );
      else if (page === PAGES.PHYSICAL)
        return (
          <table>
            <tbody>
              {row.value && (
                <tr>
                  <td>
                    <b>Element no:</b>
                  </td>
                  <td>{row.value}</td>
                </tr>
              )}
              {row.regionid && (
                <tr>
                  <td>
                    <b>Region:</b>
                  </td>
                  <td>{row.regionid}</td>
                </tr>
              )}
              {row.portfolioid && (
                <tr>
                  <td>
                    <b>Portfolio:</b>
                  </td>
                  <td> {row.portfolioid}</td>
                </tr>
              )}
              {row.stationid && (
                <tr>
                  <td>
                    <b>Station:</b>
                  </td>
                  <td>{row.stationid}</td>
                </tr>
              )}
              {row.fuel_type && (
                <tr>
                  <td>
                    <b>Fuel type:</b>
                  </td>
                  <td>{row.fuel_type}</td>
                </tr>
              )}
              {row.fuel_cost && (
                <tr>
                  <td>
                    <b>Fuel cost:</b>
                  </td>
                  <td>${row.fuel_cost}/MWhr</td>
                </tr>
              )}
            </tbody>
          </table>
        );
      break;
    case ROW_TYPE.VARIABLE:
      if (page === PAGES.PHYSICAL || page === PAGES.FINANCIAL)
        return <div>{row.description}</div>;
      break;
    default:
      console.error(`RowType ${row.rowType} not supported`);
      return null;
  }
  return null;
};

const CPPopover = ({ page, row }) => (
  <Popover title="" trigger="hover" content={PopoverRowContent(page, row)}>
    <span>
      <IconLight
        style={{ color: "#999", marginRight: "5px", fontSize: "16px" }}
        icon="info-circle"
      />
    </span>
  </Popover>
);

CPPopover.propTypes = {
  row: object.isRequired,
  page: string.isRequired
};
export default CPPopover;



// WEBPACK FOOTER //
// ./src/views/components/info_popover/InfoPopover.jsx